// extracted by mini-css-extract-plugin
export default {"tabs":"_1slb","tab":"_3kRk","active":"_1B-Y"};